export default __webpack_public_path__ + "assets/images/50d807c25a80351c81152b8326aa8246.jpg";